import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DataService } from '../../services/data.service';
import { environment } from 'src/environments/environment';
import { ExamGradeActionType } from 'src/app/models/enums/examGradeActionType';
import { Grade, GradeType } from '../../interfaces/grade';
import { StudentDataType } from 'src/app/models/enums/StudentDataType';

const typesColors = {
  exams: '#FF9900',
  assignments: '#BA73E5',
  quiz: '#1BA9F9',
  grade: '#0237C0'
};
@Component({
  selector: 'app-widget-recently-received-grades',
  templateUrl: './widget-recently-received-grades.component.html',
  styleUrls: ['./widget-recently-received-grades.component.scss', './widget-recently-received-grades.component.en.scss']
})
export class WidgetRecentlyReceivedGradesComponent implements OnInit {
  @Input({ required: true }) widgetData!: any;
  @Output() widgetLoaded: EventEmitter<any> = new EventEmitter<any>();

  gradeTypes: GradeType[] = [];
  private mockGrade: Grade = {
    id: 0,
    assignmentText: "",
    rating: 0,
    finalScore: false,
    viewGrades: false,
    actions: true,
    date: "",
    type: 4,
    state: "",
    gradeType: {
      name: '',
      type: StudentDataType.Assignment,
      links: [],
      color: ''
    }
  };
  
  grades: Grade[] = Array.from({ length: 3 }, () => (this.mockGrade));
  
  displayedColumns: string[] = ['assignmentText', 'type', 'gradeDate', 'actions'];
  loading: boolean = false;
  isServerError: boolean = false;

  constructor(private dataService: DataService) { }

  ngOnInit(): void {
    this.gradeTypes = this.widgetData.gradeTypes;
    this.gradeTypes.forEach(x => x.color = this.getGradeTypeColor(x.type));
    this.getData();
  }

  getData() { 
    this.loading = true;
    let url = environment.apiUrl + '/Portal/Api/Widgets/GetGradesForWidget';
    let request: any = {
      cultureCode: this.dataService.getCultureCode(),
      maxDisplayItems: this.widgetData.maxDisplayItems
    };
    this.dataService.getDataByToken(url, request).subscribe({
      next: (responseData) => {
        this.grades = responseData;
        this.grades.forEach(x => x.gradeType = this.gradeTypes.find(t => t.type == x.type)!)
        this.widgetLoaded.emit();
        this.loading = false;
      },
      error: (e: any) => {
        console.error(e);
        this.loading = false;
        this.isServerError = true;
      }
    });
  }

  private getGradeTypeColor(type: StudentDataType) : string {
    switch (type) {
      case StudentDataType.Assignment:
        return typesColors.assignments;
      case StudentDataType.Quiz:
        return typesColors.quiz
      case StudentDataType.CourseGrade:
        return typesColors.grade
      case StudentDataType.Exam:
        return typesColors.exams
      default:
        return "";
    }
  }
}
